import App from './containers/App';
import StaticComponentRenderer from './containers/StaticComponentRenderer';
import {
  Home,
  Landing,
  LoggedInPage,
  SeasonTicket,
  LoginWall,
  ConsentsWall,
  Register,
  Revoke,
  SearchResults,
  Checkout,
  AddListing,
  ReferFriend,
  EditListing,
  VehiclePage,
  PaymentsPage,
  WithdrawalPage,
  UpdatePrompt,
  ParkingSpaces,
  Availability,
  PartnerCheckout,
  PartnerSearchResults
} from './pages/Pages';

import NotFound from './components/Common/NotFound';

export default () => [
  {
    component: StaticComponentRenderer,
    path: '/jp/components/:component',
    exact: true
  },
  {
    component: Revoke,
    path: '/auth/consents/revoke',
    exact: true,
    strict: false
  },
  {
    component: App,
    routes: [
      {
        component: Home,
        path: '/',
        exact: true
      },
      {
        component: ConsentsWall,
        path: '/dashboard/profile/data-preferences/',
        exact: true,
        strict: false
      },
      {
        component: Landing,
        path: '/:country/parking/:slug/',
        exact: true,
        strict: true
      },
      {
        component: LoginWall,
        path: '/auth/login',
        exact: true,
        strict: false
      },
      {
        component: ConsentsWall,
        path: '/consent-wall',
        exact: true,
        strict: false
      },
      {
        component: Register,
        path: '/registration',
        exact: true,
        strict: false
      },
      {
        component: SearchResults,
        path: '/search/',
        exact: true,
        meta: {
          routeType: 'search'
        }
      },
      {
        component: PartnerSearchResults,
        path: '/partner/:partnerName/search/',
        exact: true,
        meta: {
          routeType: 'search'
        }
      },
      {
        component: Checkout,
        path: '/checkout/:listingId',
        exact: true,
        meta: {
          routeType: 'checkout',
          hideFooter: true
        }
      },
      {
        component: PartnerCheckout,
        path: '/partner/:partnerName/checkout/:listingId',
        exact: true,
        meta: {
          routeType: 'checkout',
          hideFooter: true
        }
      },
      {
        // User for integration test
        component: LoggedInPage,
        path: '/loggedInOnly',
        exact: true
      },
      {
        component: SeasonTicket,
        path: '/season-tickets/:vendor',
        exact: true
      },
      {
        component: AddListing,
        path: '/dashboard/listings/add',
        meta: {
          routeType: 'add_listing',
          headerHidePrimaryNav: true,
          headerMinimalBackground: true,
          headerDarkMobileMenu: true,
          hideFooter: true
        }
      },
      {
        component: ParkingSpaces,
        path: '/dashboard/parking-spaces',
        exact: true,
        meta: {
          routeType: 'dashboard_parking_spaces',
          headerMinimalBackground: true
        }
      },
      {
        component: EditListing,
        path: '/dashboard/listings/edit/:listingId',
        exact: true,
        meta: {
          routeType: 'edit_listing',
          headerHidePrimaryNav: true,
          headerMinimalBackground: true,
          headerDarkMobileMenu: true,
          hideFooter: true
        }
      },
      {
        component: UpdatePrompt,
        path: '/dashboard/listings/check/:id',
        exact: true,
        meta: {
          headerHidePrimaryNav: true,
          hideFooter: true,
          headerDarkMobileMenu: true
        }
      },
      {
        component: Availability,
        path: '/dashboard/parking-spaces/:listingId/availability/',
        exact: true,
        state: {
          page: 'home'
        },
        meta: {
          headerHidePrimaryNav: true,
          headerMinimalBackground: true,
          hideFooter: true,
          routeType: 'dashboard_availability'
        }
      },
      {
        component: ReferFriend,
        path: '/refer-a-friend',
        exact: true,
        meta: {
          routeType: 'refer_friend'
        }
      },
      {
        component: VehiclePage,
        path: '/vehicles',
        exact: true,
        meta: {
          routeType: 'dashboard_vehicles',
          hideFooter: true
        }
      },
      {
        component: PaymentsPage,
        path: '/dashboard/billing/payment-sources',
        exact: true,
        meta: {
          routeType: 'dashboard_payments'
        }
      },
      {
        component: WithdrawalPage,
        path: '/dashboard/billing/withdrawal',
        exact: true,
        meta: {
          routeType: 'dashboard_withdrawal'
        }
      },
      {
        path: '*',
        component: NotFound
      }
    ]
  }
];
